import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseServiceWithFilter } from './base.service';
import { Observable } from 'rxjs';
import { ClientFilter } from '@cl/shared/models/clients/client-filter.model';
import { Client } from '@cl/shared/models';

@Injectable({ providedIn: 'root' })
export class ClientsService extends BaseServiceWithFilter<Client, ClientFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/clients/');
    }

    createNewClient(obj: Client, fromSearchField: boolean): Promise<number> {
        if (fromSearchField) {
            return this.httpClient.post<number>(this.baseApiUrl + 'from-search-field', obj).toPromise();
        }
        return this.httpClient.post<number>(this.baseApiUrl, obj).toPromise();
    }

    isPersonCodeUnique(code: string, id: number): Observable<boolean> {
        return this.httpClient.get<boolean>(`${this.baseApiUrl}${code}/unique/${id}`);
    }

    toString(object: Client): string {
        if (!object) return;
        return `${object.name || ''} ${object.surname || ''} ${object.clientEmail ? ['(', object.clientEmail, ')'].join('') : ''}`;
    }

    toLongString(object: Client): string {
        const contactParts: string[] = [object.clientEmail, object.phone].filter((part: string): boolean => !!part);
        return !object ? '' : `${object.name || ''} ${object.surname || ''} ${contactParts.length > 0 ? `(${contactParts.join(', ')})` : ''}`;
    }
}
